module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/41.bd64e149.png";